module.exports = __webpack_public_path__ + "static/media/model-release-form.8c81fe26.svg";